<template>
    <div>
        <div class="content" v-if="uploadFiles.length === 0 && !loading">
            <div class="tab-container" @dragover.prevent @drop.prevent>
                <button class="btn-secondary-blue" v-on:click="handleUploadButtonClick()">新增存證檔案</button>
                <p class="my-4">僅計算檔案雜湊值，本系統不會保存您的檔案</p>
                <label class="btn-upload" @drop="dragFile">
                    <input type="file" ref="input" multiple v-on:change="onFileChange" />
                </label>
            </div>
        </div>
        <UploadFile v-if="uploadFiles.length !== 0 && !loading" :items="uploadFiles" :handleDelete="handleDelete" :setLoading="setLoading" :setFinished="setFinished" :onFileChange="onFileChange" :setProgress="setProgress" :timer="timer" />
        <Loading v-if="loading" :finished="finished" :progressNum="progressNum" :sec="sec" :msec="msec" />
    </div>
</template>
<script>
import UploadFile from './UploadFile.vue'
import Loading from './UploadLoading.vue'
import { sha256 } from '../utils/functions.js'
export default {
    name: "UploadPage",
    components: {
        UploadFile,
        Loading
    },
    data() {
        return {
            uploadFiles: [],
            loading: false,
            finished: false,
            timer: 0,
            progressNum: 0,
            sec: 0,
            msec: 0,
        };
    },
    methods: {
        setLoading(loading) {
            this.loading = loading;
        },
        setFinished(finished) {
            this.finished = finished;
        },
        setProgress(percentage) {
            console.log(percentage)
            // console.log(new Date().getTime());
            // console.log(this.progressNum);
            // if(enable){
            //     this.progressNum += 5;
            // }else{
            //     clearInterval(this.timer);
            //     this.progressNum = 100;
            // }
            this.progressNum = percentage;
        },
        async onFileChange(event) {
            const files = event?.target?.files;
            console.log(files);
            if (files) {
                let limitSize = 51 * 1024 * 1024;
                let limitNumber = 50
                const indexStart = this.uploadFiles.length + 1
                for (let i = 0; i < limitNumber; i++) {
                    const file = files[i];
                    if(file.size > limitSize){
                        alert('此存證展示平台，限制單一檔案大小為50M，檔案[ '+ file.name + ' ]已超出限制。');
                        continue;
                    }
                    const hashString = await sha256(file);
                    this.uploadFiles.push({
                        index: i + indexStart,
                        fileName: file.name,
                        hash: hashString,
                        _rowVariant: 'light',
                    });
                }
            }
        },
        handleUploadButtonClick() {
            this.$refs.input.click();
        },
        handleDelete(index) {
            this.uploadFiles.splice(index, 1);
            this.uploadFiles = this.uploadFiles.map((file, i) => {
                return {
                    ...file,
                    index: i + 1
                }
            })
        },
        async dragFile(event) {
            const files = event?.dataTransfer?.files;
            if (files) {
                let limitSize = 51 * 1024 * 1024;
                let limitNumber = 5
                const indexStart = this.uploadFiles.length + 1
                for (let i = 0; i < limitNumber; i++) {
                    const file = files[i];
                    if(file.size > limitSize){
                        alert('此存證展示平台，限制單一檔案大小為50M，檔案[ '+ file.name + ' ]已超出限制。');
                        continue;
                    }
                    const hashString = await sha256(file);
                    this.uploadFiles.push({
                        index: i + indexStart,
                        fileName: file.name,
                        hash: hashString,
                        _rowVariant: 'light',
                    });
                }
            }
        }
    },
    mounted() {
        if (!sessionStorage.getItem('username') && !sessionStorage.getItem('organs')) {
            this.$router.push('/');
        }
    }
};
</script>
